var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7.875H6.5M20.25 13.375H6.5M1 23L5.57092 20.7145C5.91742 20.5412 6.09067 20.4546 6.2723 20.3936C6.43345 20.3394 6.59941 20.3002 6.76785 20.2765C6.9576 20.25 7.15134 20.25 7.53868 20.25H21.35C22.8902 20.25 23.6602 20.25 24.2485 19.9502C24.7659 19.6867 25.1866 19.2659 25.4503 18.7485C25.75 18.1603 25.75 17.3901 25.75 15.85V5.4C25.75 3.85985 25.75 3.08978 25.4503 2.50153C25.1866 1.98407 24.7659 1.56338 24.2485 1.29974C23.6602 1 22.8901 1 21.35 1H5.4C3.85987 1 3.08973 1 2.5015 1.29974C1.98409 1.56338 1.56334 1.98407 1.29975 2.50153C1 3.08978 1 3.85986 1 5.4V23Z",
    stroke: "url(#paint0_linear_5711_4716)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5711_4716",
    x1: 13.375,
    y1: 1,
    x2: 13.375,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#FF00D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.25a76e7efb8137e99070dc53cee07be7.svg";
export { ForwardRef as ReactComponent };